import moment from "moment";
import * as Yup from "yup";

const createLotteryValidationSchema = Yup.object().shape({
  lotteryName: Yup.string()
    // .matches(/^[A-Za-z\s]+$/, "Lottery Name must contain alphabets only")
    .required("Lottery Name is required"),
  ticketPrice: Yup.number()
    .typeError("Must be a number")
    .moreThan(0, "Must be greater than 0")
    .required("Ticket price is required"),
  numOfTicketOnSale: Yup.number()
    .typeError("Must be a number")
    .moreThan(0, "Must be greater than 0")
    .required("Number of tickets on sale is required"),

  maxNumOfTickets: Yup.number().typeError("Must be a number")
    .moreThan(0, "Must be greater than 0").required("Maximum number of tickets is required"),
  startDate: Yup.string()
    .required("Start Date is required")
    .test("is-valid-date", "Invalid date", (value) => {
      return value && moment(value).isValid() && moment(value).isAfter(moment().subtract(1, 'day'));
    }),
  endDate: Yup.date().required("End date is required"),
  lotteryDrawDate: Yup.date().required("Lottery draw date is required"),

  totalDraw: Yup.number().min(1, "Must be at least 1").required("Total draw is required"),

  maxTktPurchLimit: Yup.number().min(1, "Must be at least 1").required("Max ticket purchase limit is required"),
  status: Yup.boolean().required("Status is required"),
  instruction: Yup.string(),
  drawPrizes: Yup.array()
    .of(
      Yup.number()
        .required("Draw prize is required")
        .min(1, "Draw prize must be greater than 0")
    )
    .test("match-total-draw", "You must enter the correct number of prizes", function (value) {
      const { totalDraw } = this.parent;
      if (!totalDraw || !Array.isArray(value)) return false;
      return value.length === totalDraw;
    }),

  totalSpin: Yup.number()
    .min(0, "Must be ≥ 0")
    .test(
      "totalSpin-not-greater-than-totalDraw",
      "Total Spin cannot be greater than Total Draw",
      function (value) {
        const { totalDraw } = this.parent; 
        if (value === undefined || value === null) return true; 
        return value <= totalDraw;
      }
    ),
 freeTicketSpinNo: Yup.array().when("totalSpin", {
    is: (val) => val > 0,
    then: (schema) =>
      schema
        .required("Spin numbers are required")
        .length(
          Yup.ref("totalSpin"),
          "Spin numbers are required"
        )
        .of(
          Yup.number()
            .required("Spin number is required")
           
        )
        .test(
          "unique",
          "Spin numbers must be unique",
          (arr) => Array.isArray(arr) && new Set(arr).size === arr.length
        ),
    otherwise: (schema) => schema.notRequired(),
  }),

  freeTicketSpinPrize: Yup.array().when("totalSpin", {
    is: (val) => val > 0,
    then: (schema) =>
      schema
        .required("Spin prizes are required")
        .length(
          Yup.ref("totalSpin"),
          "Spin prizes are required"
        )
        .of(
          Yup.number()
            .required("Prize is required")
            .typeError("Prize must be a number")
        ),
    otherwise: (schema) => schema.notRequired(),
  }),



});

export default createLotteryValidationSchema;
